export default __webpack_public_path__ + "static/media/274.c414bda6.png";